var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 12.1924H8.42676V19.875H10.8359V12.1924Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3584 12.0259C17.2696 12.0148 17.1752 12.0093 17.0809 12.0037C15.732 11.9482 14.9715 12.7476 14.705 13.0917C14.6329 13.1861 14.5996 13.2416 14.5996 13.2416V12.2147H12.2959V19.8972H14.5996H14.705C14.705 19.1146 14.705 18.3374 14.705 17.5547C14.705 17.1328 14.705 16.711 14.705 16.2891C14.705 15.7673 14.6662 15.2122 14.9271 14.7348C15.1491 14.3351 15.5488 14.1353 15.9984 14.1353C17.3307 14.1353 17.3584 15.3399 17.3584 15.4509C17.3584 15.4564 17.3584 15.462 17.3584 15.462V19.9305H19.7675V14.918C19.7675 13.2027 18.896 12.1925 17.3584 12.0259Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63225 11.1961C10.4048 11.1961 11.0311 10.5699 11.0311 9.79729C11.0311 9.02472 10.4048 8.39844 9.63225 8.39844C8.85968 8.39844 8.2334 9.02472 8.2334 9.79729C8.2334 10.5699 8.85968 11.1961 9.63225 11.1961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/LN.622b5d2238d655a3acabedd12694f5e6.svg";
export { ForwardRef as ReactComponent };